import * as React from 'react';
import wrapStore from '@src/utils/wrap-store';
import StrategyStore from './store';
import Link from '@src/components/link';
import cx from 'classnames';
import $$tracker from '@src/tracker';
import DateUtil from '@src/utils/date-util';

const styles = require('./index.less');

const Strategy = ({ store }) => {
  store.use();

  return (
    <div className={styles.strategy}>
      <div className={styles.content}>
        <div className={styles.title} data-name="攻略资料" />
        <div className={styles.strategyImg} data-name="攻略资料-图">
          {store.strategyImgs.slice(0, 3).map((item, index) => (
            <div
              className={styles.strategyImgItem}
              key={index}
              onClick={() => {
                store.gotoDetail(item);
                $$tracker.clickGlzlLunbotu(item.name);
              }}
            >
              <img src={item.img} alt={item.name} />
            </div>
          ))}
        </div>
        <div className={styles.strategyAction} data-name="攻略资料-tab切换">
          <div className={styles.tabs}>
            {Object.keys(store.tabs)
              .filter(item => !store.tabs[item].hidden)
              .map((item, index) => {
                const { title, imgIndex } = store.tabs[item];
                return (
                  <Link
                    className={cx(
                      styles.tabItem,
                      styles[`newTabItem${typeof imgIndex === 'number' ? imgIndex : index}`],
                      store.currentTab === item && styles.tabItemActive
                    )}
                    key={item}
                    onClick={() => {
                      $$tracker.clickGlzlNav(title);
                      store.changeTab(item);
                    }}
                  >
                    {/* {title} */}
                    <span />
                  </Link>
                );
              })}
          </div>
          <Link
            className={styles.more}
            data-name="攻略资料-查看更多"
            onClick={() => {
              $$tracker.clickGlzlMore();
              store.gotoList(store.currentTab);
            }}
          />
        </div>

        <div className={styles.strategyInfo}>
          {store.news?.slice(0, 10).map((item, index) => (
            <div
              className={styles.strategyInfoItem}
              key={index}
              onClick={() => {
                $$tracker.clickGlzlArticle(item.title);
                store.gotoDetail(item);
              }}
            >
              <div className={styles.strategyInfoItemInfo}>
                <div className={styles.strategyInfoItemTag}>{item.categoryName}</div>
                <div className={styles.strategyInfoItemTitle}>{item.title}</div>
              </div>
              <div className={styles.strategyInfoItemDate}>
                <div className={styles.month}>{DateUtil.formatDate(new Date((item.published_at_show || item.publish_at_show) * 1000), 'MM')}</div>
                <div className={styles.day}>{DateUtil.formatDate(new Date((item.published_at_show || item.publish_at_show) * 1000), 'dd')}</div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default wrapStore(Strategy, StrategyStore);
